var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$slots.default || _vm.text)?_c('portal',{attrs:{"to":"header","order":1}},[_c('h1',{staticClass:"page-title-heading"},[_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }